<script lang="ts" setup="">
defineProps<{
  disabled: boolean
  hasErrors: boolean
}>()
</script>

<template>
  <label
    data-test="input-label"
    :class="{
      'text-general-primary': !disabled && !hasErrors,
      'text-disabled-medium-emphasis': disabled,
    }"
    class="mb-2 block text-ui-label-14"
  >
    <slot />
  </label>
</template>
